var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78033 11.2803C6.51406 11.5466 6.0974 11.5708 5.80379 11.3529L5.71967 11.2803L0.71967 6.28033C0.453403 6.01406 0.429197 5.5974 0.647052 5.30379L0.71967 5.21967L5.71967 0.21967C6.01256 -0.0732231 6.48744 -0.0732231 6.78033 0.21967C7.0466 0.485937 7.0708 0.9026 6.85295 1.19621L6.78033 1.28033L2.311 5.75L6.78033 10.2197C7.0466 10.4859 7.0708 10.9026 6.85295 11.1962L6.78033 11.2803Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyArrowLeft);
export default __webpack_public_path__ + "static/media/monthly-arrow-left.0e03d09632f56c8dbb3f1b7a83fed62c.svg";
export { ForwardRef as ReactComponent };